import { render, staticRenderFns } from "./ApfMISSupportingDocument.vue?vue&type=template&id=48acf09f"
import script from "./ApfMISSupportingDocument.vue?vue&type=script&lang=js"
export * from "./ApfMISSupportingDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports